/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/VaiController.json';
import { VaiController } from 'libs/contracts/generated/infos/contractTypes';
import { getUniqueContractAddress } from 'libs/contracts/utilities/getUniqueContractAddress';
import { useChainId, useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetVaiControllerContractAddressInput {
  chainId: ChainId;
}

export const getVaiControllerContractAddress = ({
  chainId,
}: GetVaiControllerContractAddressInput) =>
  getUniqueContractAddress({ name: 'VaiController', chainId });

export const useGetVaiControllerContractAddress = () => {
  const { chainId } = useChainId();

  return useMemo(
    () =>
      getVaiControllerContractAddress({
        chainId,
      }),
    [chainId],
  );
};

interface GetVaiControllerContractInput {
  chainId: ChainId;
  signerOrProvider: Signer | Provider;
}

export const getVaiControllerContract = ({
  chainId,
  signerOrProvider,
}: GetVaiControllerContractInput) => {
  const address = getVaiControllerContractAddress({ chainId });
  return address ? (new Contract(address, abi, signerOrProvider) as VaiController) : undefined;
};

interface UseGetVaiControllerContractInput {
  passSigner?: boolean;
  chainId?: ChainId;
}

export const useGetVaiControllerContract = (input?: UseGetVaiControllerContractInput) => {
  const { chainId: currentChainId } = useChainId();
  const chainId = input?.chainId || currentChainId;

  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = input?.passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getVaiControllerContract({
            chainId,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, chainId],
  );
};
